import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { useContactInfo } from "@/context/SiteContentContext";

export default function WhatsAppButton() {
  const { t } = useLang();
  const CONTACT_INFO = useContactInfo();
  const href = `https://wa.me/${CONTACT_INFO.whatsapp}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1.4, type: "spring" }}
      whileHover={{ scale: 1.08 }}
      className="fixed bottom-6 start-6 z-[60] h-14 w-14 rounded-full grid place-items-center shadow-2xl group"
      style={{ background: "#25D366", boxShadow: "0 0 24px rgba(37,211,102,0.5)" }}
      data-testid="whatsapp-button"
      aria-label={t.whatsapp}
    >
      <span className="absolute inset-0 rounded-full animate-ping opacity-30" style={{ background: "#25D366" }} />
      <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff" className="relative z-10">
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 018.413 3.488 11.82 11.82 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.518 5.26l-.999 3.648 3.98-1.04zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
      </svg>
      <span className="absolute end-16 whitespace-nowrap rounded-full bg-[#0d1836] border border-white/10 px-4 py-2 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        {t.whatsapp}
      </span>
    </motion.a>
  );
}
